import { Injectable } from '@angular/core';
import {CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree} from '@angular/router';
import {AuthService} from '@modules/authentication/services/auth.service';
import {Observable} from 'rxjs';
import {ROUTES} from "@modules/authentication/authentication-routing.module";
@Injectable()
export class AuthGuard implements CanActivate {

    constructor(
        private authService: AuthService,
        private router: Router
    ) {}

    canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): any{
          if (this.authService.isAuthenticated()) {
            return true;
          } else {
            this.router.navigate(["/" + ROUTES.PREFIX + "/" + ROUTES.LOGIN])
            return false;
          }
    }

  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    return this.canActivate(childRoute, state);
  }

}
